export class Pai {
  item: any;
}
